import { WOHNFORM_KATALOG, wohnformLabel } from '@/lib/wohnform';
/**
 * Formatierungs-Hilfsfunktionen für die gesamte Olympus-Anwendung
 */

/**
 * Formatiert ein Datum ins deutsche Format (TT.MM.JJJJ)
 * Akzeptiert ISO-Strings, Date-Objekte und deutsche Formate
 */
export function formatDatum(datum) {
  if (!datum) return 'k.A.';
  try {
    // Falls bereits im deutschen Format
    if (typeof datum === 'string' && /^\d{2}\.\d{2}\.\d{4}$/.test(datum)) {
      return datum;
    }
    const d = new Date(datum);
    if (isNaN(d.getTime())) return datum;
    return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch {
    return datum;
  }
}

/**
 * Wohnform-Werte → menschenlesbare Labels
 */
// Wohnform-Katalog zentral in lib/wohnform.js (eine Quelle fuer Lebenssituation und Verguetung)
export const WOHNFORM_LABELS = Object.fromEntries([['nicht_angegeben', 'Offen / nicht angegeben'], ...WOHNFORM_KATALOG.map(x => [x.value, x.label])]);

/**
 * Gibt das menschenlesbare Label für eine Wohnform zurück
 */
export function formatWohnform(wert) {
  if (!wert) return 'k.A.';
  return wohnformLabel(wert);
}

/**
 * Familienstand-Werte → menschenlesbare Labels
 */
export const FAMILIENSTAND_LABELS = {
  nicht_angegeben: 'Nicht angegeben',
  ledig: 'Ledig',
  verheiratet: 'Verheiratet',
  geschieden: 'Geschieden',
  verwitwet: 'Verwitwet',
  getrennt_lebend: 'Getrennt lebend',
  eingetragene_lebenspartnerschaft: 'Eingetragene Lebenspartnerschaft',
};

export function formatFamilienstand(wert) {
  if (!wert) return 'k.A.';
  return FAMILIENSTAND_LABELS[wert] || wert.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Geschlecht-Werte → menschenlesbare Labels
 */
export const GESCHLECHT_LABELS = {
  nicht_angegeben: 'Nicht angegeben',
  maennlich: 'Männlich',
  weiblich: 'Weiblich',
  divers: 'Divers',
};

export function formatGeschlecht(wert) {
  if (!wert) return 'k.A.';
  return GESCHLECHT_LABELS[wert] || wert;
}
